import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-10b21ee9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "anquanjianchadan-container" }
const _hoisted_2 = { class: "list-container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "检查单号：", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "检查时间：", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "检查类型：", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "检查人：", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_search = _resolveComponent("van-search")!
  const _component_van_list = _resolveComponent("van-list")!
  const _component_van_pull_refresh = _resolveComponent("van-pull-refresh")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_search, {
      modelValue: _ctx.danhao,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.danhao) = $event)),
      placeholder: "请输入完整检查单号搜索"
    }, null, 8, ["modelValue"]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_van_pull_refresh, {
        modelValue: _ctx.refreshing,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.refreshing) = $event)),
        onRefresh: _ctx.onRefresh
      }, {
        default: _withCtx(() => [
          _createVNode(_component_van_list, {
            loading: _ctx.loading,
            "onUpdate:loading": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.loading) = $event)),
            finished: _ctx.finished,
            "finished-text": "没有更多了",
            "loading-text": "正在加载,请稍后..",
            onLoad: _ctx.onLoad
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.recordslist, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "list",
                  key: index,
                  style: _normalizeStyle({ marginTop: index === 0 ? '0px' : '10px' })
                }, [
                  _createElementVNode("div", null, _toDisplayString(item.billType === 1
                  ? "检查记录单"
                  : item.billType === 2
                  ? "隐患整改单"
                  : "停工整改单"), 1),
                  _createElementVNode("div", null, [
                    _hoisted_3,
                    _createElementVNode("span", null, _toDisplayString(item.billNo), 1)
                  ]),
                  _createElementVNode("div", null, [
                    _hoisted_4,
                    _createElementVNode("span", null, _toDisplayString(item.createTimestamp), 1)
                  ]),
                  _createElementVNode("div", null, [
                    _hoisted_5,
                    _createElementVNode("span", null, _toDisplayString(item.checkType === 1
                  ? "监督检查"
                  : item.billType === 2
                  ? "企业检查"
                  : "项目检查"), 1)
                  ]),
                  _createElementVNode("div", null, [
                    _hoisted_6,
                    _createElementVNode("span", null, _toDisplayString(item.checkUserName), 1)
                  ])
                ], 4))
              }), 128))
            ]),
            _: 1
          }, 8, ["loading", "finished", "onLoad"])
        ]),
        _: 1
      }, 8, ["modelValue", "onRefresh"])
    ])
  ]))
}